import styled from 'styled-components'
import { SharedNav } from '@chegg-wt/core/theme/sunkist/nav'

export const Container = styled.div`
  ${SharedNav};
  padding: 12px;
  margin-bottom: 16px;
  display: flex;
`

export const Logo = styled.img`
  height: 30px;
  cursor: pointer;
`

export const Loading = styled.div`
  background: white;
  left: 50%;
  top: 160px;
  width: 122px;
  height: 45px;
  margin-left: -61px;
  position: absolute;
  border-radius: 50px;
  text-align: center;
  vertical-align: middle;
`

export const RfNoDistractionContainer = styled.div`
  margin-bottom: 16px;
`
